import { useQuery } from '@tanstack/react-query';
import { SupportRequestApi, ISupportContactInfo } from '../../../apis/SupportRequestApi/SupportRequestApi';

export function useGetSupportContactInfo(enabled: boolean) {
    return useQuery<ISupportContactInfo>({
        queryKey: ['supportRequest', 'contactInfo'],
        queryFn: () => SupportRequestApi.getContactInfo(),
        enabled,
    });
}
